import type { IHooksUseRequestCertifyProfileParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestCertifyProfileParams;
type TResponseData = void;

export const useRequestCertifyProfile = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending: isLoadingCertification, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.certifications.base, 'certify'],
    mutationFn: ({ accept, ...data }: TDataVariables) =>
      apiClient
        .post<TResponseData>(`${routes.api.certifications.actions}/${(accept ? 'accept' : 'deny')}`, data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'profileCertified', data: ({ accept, ...data }) })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.verifications.count),
          invalidate(routes.api.certifications.base),
          invalidate(routes.api.dashboard)
        ])
    )
  });

  const triggerCertification = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingCertification,
    triggerCertification,
    error
  });

};  
